module.exports = __webpack_public_path__ + "static/media/UV-Protective_Face_Shield.5161b768.svg";